module.exports = __webpack_public_path__ + "img/typescript.68469a16.svg";